import facebook from '../images/facebook.png';
import instagram from '../images/instagram.png';
import linkedin from '../images/linkedin.png';
import twitter from '../images/twitter.png';
import youtube from '../images/youtube.png';
import reddit from '../images/reddit.png';
import tiktok from '../images/tiktok-icon.png';

export const icons = [
    { media: facebook, link: '//facebook.com/themutualapp/', alt: 'facebook icon' },
    { media: instagram, link: '//instagram.com/mutual_app?utm_medium=copy_link', alt: 'instagram icon' },
    { media: twitter, link: '//twitter.com/mutual_app?s=20', alt: 'twitter icon' },
    { media: youtube, link: '//youtube.com/channel/UCcXhksYDJb6Rx_O5Y84_1PA', alt: 'youtube icon' },
    { media: reddit, link: '//www.reddit.com/r/mutualapp/', alt: 'reddit icon' },
    { media: linkedin, link: '//www.linkedin.com/company/mutual---lds-dating', alt: 'linkedin icon' },
    { media: tiktok, link: 'https://www.tiktok.com/@mutual_app', alt: 'tiktok icon' },
]